import { defineAsyncComponent } from 'vue';

const GLVoucherDetail = defineAsyncComponent(() => import('@/views/summary/gLVoucher/GLVoucherDetail.vue'));

const GLBeginningYearTransferDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLBeginningYearTransfer/GLBeginningYearTransferDetail.vue')
);

const ApproveVoucherGLBeginningYearTransferTab = defineAsyncComponent(() =>
  import('@/views/summary/gLBeginningYearTransfer/ApproveVoucherGLBeginningYearTransferTab.vue')
);

const GLProfitLossTransferDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLProfitLossTransfer/GLProfitLossTransferDetail.vue')
);

const ApproveGLProfitLossTransferTab = defineAsyncComponent(() =>
  import('@/views/summary/gLProfitLossTransfer/ApproveGLProfitLossTransferTab.vue')
);

const GLEndYearTransferDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLEndYearTransfer/GLEndYearTransferDetail.vue')
);

const GLProvisionalTaxInComeEnterpriseDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucher/GLProvisionalTaxInComeDetail.vue')
);

const GLFinalTaxInComeEnterpriseDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucher/GLFinalTaxInComeEnterpriseDetail.vue')
);

const IncomeTaxVoucherPopup = defineAsyncComponent(() => import('@/views/summary/gLVoucher/IncomeTaxVoucherPopup.vue'));

const GLVoucherSummaryTableDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucherSummaryTable/GLVoucherSummaryTableDetail.vue')
);

const ChooseVoucherPopup = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucherSummaryTable/ChooseVoucherPopup.vue')
);

const ChooseVoucherSummaryPopup = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucherSummaryTable/ChooseVoucherSummaryPopup.vue')
);

const GLPostedVoucherDetail = defineAsyncComponent(() =>
  import('@/views/summary/gLPostedVoucher/GLPostedVoucherDetail.vue')
);

const StatisticalDayOffDetail = defineAsyncComponent(() =>
  import('@/views/salary/statisticalDayOff/StatisticalDayOffDetail.vue')
);

const VoucherSearch = defineAsyncComponent(() => import('@/views/voucher/VoucherSearch.vue'));
const FormPrintVoucher = defineAsyncComponent(() => import('@/views/voucher/FormPrintVoucher.vue'));

const CloseoutVoucherPopup = defineAsyncComponent(() =>
  import('@/views/summary/processSummary/CloseoutVoucherPopup.vue')
);
const ApproveVoucherGLEndYearTransferTab = defineAsyncComponent(() =>
  import('@/views/summary/gLEndYearTransfer/ApproveVoucherGLEndYearTransferTab.vue')
);

const ApproveVoucherGLVoucherTab = defineAsyncComponent(() =>
  import('@/views/summary/gLVoucher/ApproveVoucherGLVoucherTab.vue')
);

const ApproveVoucherBATransferTab = defineAsyncComponent(() =>
  import('@/views/deposits/bATransfer/ApproveVoucherBATransferTab.vue')
);

const ApproveGLPayrollExpenseTab = defineAsyncComponent(() =>
  import('@/views/salary/gLPayrollExpenseSalary/ApproveGLPayrollExpenseTab.vue')
);

export function registerGL(app) {
  app.component('GLGeneralVoucherDetail', GLVoucherDetail);
  app.component('GLBeginningYearTransferDetail', GLBeginningYearTransferDetail);
  app.component('ApproveVoucherGLBeginningYearTransferTab', ApproveVoucherGLBeginningYearTransferTab);
  app.component('GLProfitLossTransferDetail', GLProfitLossTransferDetail);
  app.component('GLEndYearTransferDetail', GLEndYearTransferDetail);
  app.component('GLProvisionalTaxInComeEnterpriseDetail', GLProvisionalTaxInComeEnterpriseDetail);
  app.component('GLFinalTaxInComeEnterpriseDetail', GLFinalTaxInComeEnterpriseDetail);
  app.component('IncomeTaxVoucherPopup', IncomeTaxVoucherPopup);
  app.component('GLVoucherSummaryTableDetail', GLVoucherSummaryTableDetail);
  app.component('ChooseVoucherPopup', ChooseVoucherPopup);
  app.component('ChooseVoucherSummaryPopup', ChooseVoucherSummaryPopup);
  app.component('GLPostedVoucherDetail', GLPostedVoucherDetail);
  app.component('StatisticalDayOffDetail', StatisticalDayOffDetail);
  app.component('VoucherSearch', VoucherSearch);
  app.component('FormPrintVoucher', FormPrintVoucher);
  app.component('CloseoutVoucherPopup', CloseoutVoucherPopup);
  app.component('ApproveVoucherGLEndYearTransferTab', ApproveVoucherGLEndYearTransferTab);
  app.component('ApproveVoucherGLVoucherTab', ApproveVoucherGLVoucherTab);
  app.component('ApproveGLProfitLossTransferTab', ApproveGLProfitLossTransferTab);
  app.component('ApproveVoucherBATransferTab', ApproveVoucherBATransferTab);
  app.component('ApproveGLPayrollExpenseTab', ApproveGLPayrollExpenseTab);
}
